export default "__VITE_ASSET__C9AGGXIS__ 480w, __VITE_ASSET__BirhmoGt__ 768w, __VITE_ASSET__eArKJRrp__ 899w";